import { apiWrapper } from 'ccs-ui-components';
import { useState } from 'react';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IActiveSource } from '../../../store/actions/types/sources/GetAllSourceRegistries';
import { sourceListRegistrySchema } from '../../../utilities/sources/RegistriesSchemaDefintion';

const useSourceEventAssociation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  async function callSourceEventAssociation(queryParams: { [key: string]: string }, eventName: string, eventVersion: string) {
    setIsLoading(true);
    const resp = await apiWrapper.post<IActiveSource, { errorMessage: string }>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/sources/search?page=${queryParams.page}&size=${queryParams.item}&sort=${queryParams.sort},${queryParams.type}`,
      {
        sources: queryParams.sourceName ? [{ sourceName: queryParams.sourceName }] : undefined,
        status: queryParams.status ? queryParams.status.split(',') : undefined,
        eventName,
        eventVersion,
        exactNameMatch: false

      },
      headersInstance()
    );

    const apiResponse = sourceListRegistrySchema.validate(resp.responseBody, {
      abortEarly: true
    });

    if (resp.isError || !apiResponse?.value) {
      setIsLoading(false);
      setErrorMessage(resp?.errorBody?.errorMessage || '');
      return {
        errorMessage: resp.errorBody?.errorMessage,
        isError: resp.isError,
        statusCode: resp.statusCode
      };
    }
    const sourceRecords = resp.responseBody;
    setIsLoading(false);

    return {
      sourceRecords,
      statusCode: resp.statusCode
    };
  }

  const sourceEventAssociation = async (queryParam: { [key: string]: string }, eventName: string, eventVersion: string) => callSourceEventAssociation(queryParam, eventName, eventVersion);

  return { sourceEventAssociation, isLoading, errorMessage };
};

export default useSourceEventAssociation;
